import { render, staticRenderFns } from "./custom-detail-list.vue?vue&type=template&id=15ed7760&scoped=true"
import script from "./custom-detail-list.vue?vue&type=script&lang=ts"
export * from "./custom-detail-list.vue?vue&type=script&lang=ts"
import style0 from "./custom-detail-list.vue?vue&type=style&index=0&id=15ed7760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed7760",
  null
  
)

export default component.exports